import { IConfigurationItem } from "../../configuration/configurationSections";
import { IConfigurationStyles, useConfigurationStyles } from "../../layouts";
import { ConfigurationCardLink } from "./configurationItem.styled";

export interface ConfigurationItemProps extends IConfigurationItem {
    controlStyles?: IConfigurationStyles | undefined;
}

export const ConfigurationItem: React.FC<ConfigurationItemProps> = (props) => {
    const styles: IConfigurationStyles = props.controlStyles ?? useConfigurationStyles();

    return (
        <>
            {(props.isDisplayed || props.isDisplayed === undefined) && (
                <ConfigurationCardLink to={props.href}>
                    <div className="d-flex flex-row justify-content-end">
                        <div className="col-11">
                            <h5 style={styles.tileTitle} >{props.title}</h5>
                            <span style={styles.titleSubtitle} className="mb-2">{props.subtitle}</span>
                        </div>
                        <div className="col pt-2 text-end">
                            <span style={styles.tileCaret} className="bi bi-chevron-right align-middle"></span>
                        </div>
                    </div>
                </ConfigurationCardLink>
            )}
        </>
    );
};